import { render, staticRenderFns } from "./EventsById.vue?vue&type=template&id=dd3eab84&scoped=true&"
import script from "./EventsById.vue?vue&type=script&lang=js&"
export * from "./EventsById.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3eab84",
  null
  
)

export default component.exports